export default class Image {
    url = null;
    new_image_data = null;
    crop_changed = false;
    crop_data = null;
    delete_image = false;

    constructor(url) {
        this.url = url;
    }

    selectFromLibrary(file) {
        this.url = file.webPath;
        this.new_image_data = file;
        this.crop_changed = false;
        this.crop_data = null;
        this.delete_image = false;
    }

    reset() {
        this.url = null;
        this.new_image_data = null;
        this.crop_changed = false;
        this.crop_data = null;
        this.delete_image = true;
    }

    setNewImageData(newImageData) {
        this.new_image_data = newImageData;
    }
}